import { ReactNode, useLayoutEffect } from "react";
import { useAuth } from "../components/auth/ParseAuthContext.tsx";
import { applyPersonaTerms } from "../i18n/i18n.ts";
import { Persona } from "../shared/persona.ts";

/**
 * The roles of the signed-in user and the one they work in, and how they
 * switch to another of theirs. A law firm until someone is signed in.
 */
export function usePersona(): {
  personas: Persona[];
  active: Persona;
  switchPersona: (persona: Persona) => void;
} {
  const { auth, updateUserField } = useAuth();
  const user = auth.kind === "signedIn" ? auth.user : undefined;
  return {
    personas: user?.personas ?? ["lawFirm"],
    active: user?.activePersona ?? "lawFirm",
    switchPersona: (persona) => updateUserField("activePersona", persona),
  };
}

/**
 * Draws what it holds in the terms of the role the user works in, from the
 * first paint on.
 */
export const PersonaTerms = ({ children }: { children: ReactNode }) => {
  const { active } = usePersona();
  useLayoutEffect(() => applyPersonaTerms(active), [active]);
  return children;
};
